'use client'

import * as React from 'react'

import { useLocale } from 'next-intl'
import { useTheme } from 'next-themes'
import { Toaster as Sonner, ToasterProps } from 'sonner'

const Toaster = ({ ...props }: ToasterProps) => {
  const { resolvedTheme } = useTheme()
  const locale = useLocale()

  return (
    <Sonner
      className="toaster group"
      position={locale === 'ar' ? 'bottom-left' : 'bottom-right'}
      style={
        {
          '--border-radius': '0.75rem',
          '--normal-bg': 'var(--popover)',
          '--normal-border': 'var(--border)',
          '--normal-text': 'var(--popover-foreground)'
        } as React.CSSProperties
      }
      theme={(resolvedTheme ?? 'light') as ToasterProps['theme']}
      toastOptions={{
        classNames: {
          actionButton:
            'rounded-md! bg-primary! text-primary-foreground! hover:bg-primary/90!',
          cancelButton:
            'rounded-md! bg-secondary! text-secondary-foreground! hover:bg-secondary/80!',
          description: 'text-muted-foreground! text-sm! leading-snug!',
          error:
            'bg-linear-to-r! from-destructive/10! to-destructive/10! border-s-4! border-s-destructive! [&>[data-icon]]:text-destructive! [&_[data-title]]:text-destructive!',
          info: 'bg-linear-to-r! from-info-accent/10! to-info-accent/10! border-s-4! border-s-info-accent! [&>[data-icon]]:text-info-accent! [&_[data-title]]:text-info-accent!',
          success:
            'bg-linear-to-r! from-success-foreground/10! to-success-foreground/10! border-s-4! border-s-success-foreground! [&>[data-icon]]:text-success-foreground! [&_[data-title]]:text-success-foreground!',
          title: 'font-medium! text-sm! leading-tight!',
          toast:
            'p-4! gap-3! shadow-xl! shadow-black/5! backdrop-blur-xl! supports-[backdrop-filter]:bg-popover/80!',
          warning:
            'bg-linear-to-r! from-warning-foreground/10! to-warning-foreground/10! border-s-4! border-s-warning-foreground! [&>[data-icon]]:text-warning-foreground! [&_[data-title]]:text-warning-foreground!'
        }
      }}
      {...props}
    />
  )
}

export { Toaster }
